<template>
  <section :class="$style.root">
    <div :class="$style.container">
      <div :class="$style.heading">
        <h2 :class="$style.title">{{ title }}</h2>
      </div>
      <div :class="$style.content">
        <div :class="$style.row">
          <div
            v-for="(item, index) in items"
            :key="index"
            :class="$style.col"
          >
            <p :class="$style.number" v-if="item.number">{{ item.number }}</p>
            <span :class="[$style.divider, $style.mobHidden]" v-if="item.number"/>
            <p :class="$style.itemTitle" v-if="item.title">{{ item.title }}</p>
            <p :class="$style.text" v-if="item.text">{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeNumbers',
  props: {
    items: Array,
    title: String,
  },
};
</script>

<style lang="scss" module>
@import '../styles/variables';
@import '../styles/helpers';

$divider-color: #dbdbdb;
$item-title-color: $blue;
$text-color: rgba($gray-dark, 0.8);

.root {
  @extend %section;
}

.container {
  @extend %container;
}

.title {
  @extend %sectionTitle;
  margin: 0;
  margin-bottom: 70px;
  text-align: center;

  @include media('<=tablet') {
    margin-bottom: 50px;
  }
}

.divider {
  display: block;
  margin: 0 auto 6px;
  width: 68px;
  height: 3px;
  background-color: $divider-color;
}

.content {
  max-width: 1140px;
  margin: 0 auto;
  padding-left: $grid-gutter;
  padding-right: $grid-gutter;

  @include media('<=phone') {
    padding-left: $grid-gutter-mobile;
    padding-right: $grid-gutter-mobile;
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -$grid-gutter;
  margin-right: -$grid-gutter;

  @include media('<=phone') {
    margin-left: -$grid-gutter-mobile;
    margin-right: -$grid-gutter-mobile;
  }
}

.col {
  width: 33.3%;
  padding: 0 $grid-gutter;
  text-align: center;
  margin-bottom: 20px;

  @include media('<tablet') {
    position: relative;
    width: 100%;
    padding-bottom: 35px;
    margin-bottom: 35px;
  }

  @include media('<=phone') {
    padding-left: $grid-gutter-mobile;
    padding-right: $grid-gutter-mobile;
  }
}

.col::after {
  @include media('<tablet') {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 30%;
    height: 1px;
    background-color: $gray-4;
  }
}

.col:last-child {
  @include media('<tablet') {
    padding-bottom: 0;
  }
}

.col:last-child::after {
  @include media('<tablet') {
    display: none;
  }
}

.number {
  @extend %sectionTitle;
  position: relative;
  margin: 0;
  margin-bottom: 4px;

  @include media('<=tablet') {
    font-size: 46px;
    font-weight: normal;
  }
}

.itemTitle {
  @include set-fz-lh(24, 30);
  margin: 0;
  margin-bottom: 10px;
  color: $item-title-color;

  @include media('<=tablet') {
    @include set-fz-lh(20, 30);
    font-weight: 600;
  }
}

.text {
  @include set-fz-lh(16, 25);
  margin: 0;
  color: $text-color;
}

.button {
  @extend %button;
  padding-left: 60px;
  padding-right: 60px;
}

.buttonWrapper {
  margin-top: 70px;
  text-align: center;

  @include media('<=tablet') {
    margin-top: 10px;
  }
}

.mobHidden {
  @include media('<tablet') {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeNumbers.vue